riot.tag2('bbc-notifications-list', '<div id="notifications-wrapper" onmousewheel="{this.onListMouseWheel}" onscroll="{this.onListScroll}"> <ul if="{opts.notifications.length}" class="notification-items" aria-live="polite" aria-relevant="additions" aria-atomic="true"> <li class="notification-item notification__item--js {status ? \'notification-\' + status : \'\'}" each="{opts.notifications}"> <a class="notification-item--link" href="{notification.url}" onclick="{this.onLinkClick}" onkeydown="{this.onLinkKeyDown}"> <div class="notification-icon-and-dot notification-{product.toLowerCase()}"> <span class="notification-dot {status ? \'notification-\' + status : \'\'}"></span> <div class="notifications-image notification-{product.toLowerCase()}-icon"> </div> </div> <div class="notification-text {status ? \'notification-\' + status : \'\'}"> <div class="notification-title-items"> <div> <p class="notification-text-body notifications-long-primer">{this.title(notification)}</p> </div> <div class="notification-item--info"> <span class="notification-episode-name notifications-brevier">{this.label(notification.episode, product)}</span> <span class="notification-time notifications-brevier">{sampleWhen ? sampleWhen : this.timeago(creationTimestamp)}</span> </div> </div> </div> </a> </li> </ul> <div class="spinner" if="{opts.loadingMore}"> <img class="loader-icon notifications-image spinner__img--svg" riot-src="{this.basePath + \'/svg/loader.svg\'}" alt="Spinner"> </div> <div class="notifications-keyboard-access" if="{this.showKeyboardAccess}"> <button class="notifications-keyboard-access--btn notifications-keyboard-access--more" onclick="{this.keyboardLoadMore}" __disabled="{opts.reachedEnd}">Load More</button> <button name="notificationsKeyboardClose" class="notifications-keyboard-access--btn notifications-keyboard-access--close" onclick="{this.closeDrawer}" onkeydown="{this.onKeyboardCloseDown}">Close</button> </div> </div>', '', '', function(opts) {
'use strict';

var _this = this;

var Utils = require('../utils');
var notificationsAnalytics = require('../analytics');
this.timeago = require('../vendor/timeago');

this.utils = new Utils();

var listShadowOffset = 0;
var loadMoreBuffer = 50;
this.basePath = opts.mainApp.basePath;

this.on('mount', function () {
    console.log('LIST MOUNTED', opts);
});

this.loadMore = function () {
    // eslint-disable-line consistent-return
    console.log('Active element', document.activeElement);
    if (document.activeElement && document.activeElement.classList && (document.activeElement.classList.contains('notification-item--link') || document.activeElement.classList.contains('notifications-keyboard-access--btn'))) {
        return false;
    }

    console.log('Component app', opts.componentApp);

    if (!opts.componentApp.loadingMore && !opts.componentApp.reachedEnd) {
        console.warn('Load more...');
        opts.componentApp.fetchNotifications(true);
    }
};

// Calculate overflow block
this.onListMouseWheel = function (e) {
    e.preventUpdate = true;

    if (!opts.notifications.length) {
        return true;
    }

    if (e.currentTarget.offsetHeight >= e.currentTarget.scrollHeight) {
        return true;
    }

    if (e.deltaY > 0) {
        return !(e.currentTarget.scrollTop >= e.currentTarget.scrollHeight - e.currentTarget.offsetHeight);
    }

    return !(e.currentTarget.scrollTop === 0);
};

this.onListScroll = function (e) {
    e.preventUpdate = true;

    // Calculate shadow
    if (!_this.parent.shadowAdded && e.currentTarget.scrollTop > listShadowOffset) {
        _this.parent.update({ shadowAdded: true });
    } else if (_this.parent.shadowAdded && e.currentTarget.scrollTop <= listShadowOffset) {
        _this.parent.update({ shadowAdded: false });
    }

    // Calculate load more
    if (e.currentTarget.scrollTop >= e.currentTarget.scrollHeight - e.currentTarget.offsetHeight - loadMoreBuffer) {
        _this.loadMore();
    }
};

this.capitalizeFirstLetter = function (str) {
    if (str.toLowerCase() === 'iplayer') {
        return 'iPlayer';
    }

    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

this.closeDrawer = function () {
    document.getElementById('notification-link').click();

    if (document.activeElement) {
        document.querySelector('.orb-nav-news a').focus();
    }
};

this.onLinkClick = function (e) {
    var link = e.item.notification.url;
    var status = _this.getAnalyticsNotificationStatus(e.item.status);
    // Analytics event (notificationsItem click)
    notificationsAnalytics.log('click', 'notifications-item', {
        notifications_id: e.item.id,
        notifications_state: status,
        notifications_priority: (e.item.priority || 'normal').toLowerCase(),
        notifications_product: e.item.product.toLowerCase(),
        notifications_type: e.item.type.toLowerCase(),
        notifications_title: e.item.notification.title,
        topic_name: notificationsAnalytics.serialiseTopic(e.item.topic)
    });

    opts.componentApp.notificationsModel.markRead(e.item).then(function () {
        window.location.assign(link);
    });

    if (e.preventDefault) {
        e.preventDefault();
    }

    return false;
};

this.getAnalyticsNotificationStatus = function (status) {
    switch (status) {
        case 'new':
            return 'blueDot';
        case 'unread':
            return 'new';
        default:
            return 'read';
    }
};

this.onLinkKeyDown = function (e) {
    if (e.keyCode === 9) {
        // Tab
        var next = document.activeElement.parentNode.nextSibling;
        var endOfList = !(next.classList && next.classList.contains('notification-item'));

        if (endOfList) {
            _this.update({ showKeyboardAccess: true });
        }
    }

    return true;
};

this.onKeyboardCloseDown = function (e) {
    if (e.keyCode === 9 && !e.shiftKey) {
        // Tab
        document.querySelector('.notifications__settings--js').focus();
        return false;
    }

    return true;
};

this.keyboardLoadMore = function () {
    var numNotifications = document.querySelectorAll('.notification-items .notification-item').length;
    console.log('Load more from keyboard', numNotifications);
    opts.componentApp.fetchNotifications(true).then(function () {
        var next = document.querySelector('.notification-items\n                    .notification-item:nth-child(' + (numNotifications + 1) + ') a');

        console.log('Loaded more from keyboard', next, _this.notificationsKeyboardClose);

        if (next) {
            next.focus();
        } else {
            _this.notificationsKeyboardClose.focus();
        }
    });
};

this.title = function (notification) {
    var dash = '–';
    return notification.title + (notification.episode ? ' ' + dash + ' ' + notification.episode : '');
};

this.label = function (episode, product) {
    return _this.capitalizeFirstLetter(product);
};
});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/components/bbc-notifications-list.tag
 ** module id = 24
 ** module chunks = 0
 **/